<script lang="ts" setup>
import KlereoIcon from "@/shared/components/KlereoIcon.vue";
import { computed, inject, ref } from "vue";
import KlereoModal from "@/shared/components/KlereoModal.vue";
import RenameIOForm from "@/features/probe/RenameIOForm.vue";
import { getRename } from "@/shared/utils/renames";
import { usePool } from "@/features/pool/usePool";

const props = defineProps({
  leftIcon: String,
  leftLink: String,
  leftClass: String,
  rightIcon: String,
  rightLink: String,
  rightClass: String,
  title: String,
  description: String,
  ioType: {
    required: false,
    type: Number,
  },
  ioIndex: {
    required: false,
    type: Number,
  },
});

const renameModalOpen = ref(false);

const pool = usePool();
const refreshPool = inject("refreshPool") as () => Promise<void> | undefined;

const rename = computed(
  () =>
    (props.ioType !== undefined &&
      props.ioIndex !== undefined &&
      getRename(pool, props.ioType, props.ioIndex)) ||
    undefined
);
</script>

<template>
  <div class="mb-5">
    <klereo-modal :opened="renameModalOpen" @close="renameModalOpen = false">
      <rename-i-o-form
        :io-type="ioType!"
        :io-index="ioIndex!"
        :default-label="title"
        @close="renameModalOpen = false"
      />
    </klereo-modal>
    <div class="flex text-white justify-between items-start">
      <div class="flex gap-1 lg:basis-1/6">
        <div
          class="bigger-clickable-area cursor-pointer"
          v-if="leftIcon"
          :class="leftClass + ' w-[27px] bigger-clickable-area'"
          @click="leftLink ? $router.replace(leftLink) : $emit('left')"
        >
          <klereo-icon :name="leftIcon" />
        </div>
        <slot></slot>
      </div>
      <div
        class="flex gap-2 align-items-center text-lg text-center"
        @click="$emit('title-click', $event)"
      >
        {{ rename ?? title }}
        <klereo-icon
          v-if="pool?.IORename && ioType && ioType > 0"
          class="cursor-pointer"
          name="edit"
          @click="renameModalOpen = true"
          style="width: 15px"
        />
      </div>
      <div class="flex gap-5 items-center lg:basis-1/6 justify-end">
        <klereo-icon
          v-if="rightIcon"
          :name="rightIcon"
          :class="rightClass + ' cursor-pointer w-[27px]'"
          @click="rightLink ? $router.push(rightLink) : $emit('right')"
        />
        <slot name="right-section" />
        <klereo-icon
          v-if="refreshPool"
          @click="refreshPool"
          name="refresh"
          class="cursor-pointer w-[22px]"
        />
      </div>
    </div>
    <div v-if="description" class="text-lightblue text-[11px] text-center">
      {{ description }}
    </div>
  </div>
</template>
